import { useNavigate } from 'react-router-dom';
import { TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import { TableRowItem } from './TableRowItem';
import { ITutorRequest } from '@wot/typings';
import { ISorting } from '..';
import { BiSort } from 'react-icons/bi';

interface Props {
  data: ITutorRequest[];
  handleSort?: (key: ISorting) => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto custom-scrollbar">
        <div className="py-2 inline-block">
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto">
              <TableHeading>
                <TableRow>
                  <TableHeadingCol
                    onClick={() => handleSort && handleSort('createdAt')}
                    label="Date"
                    component={
                      <div className="flex items-center">
                        <p className="">Date</p>
                        <BiSort className="text-sm" />
                      </div>
                    }
                  />
                  <TableHeadingCol label="Req ID" />
                  <TableHeadingCol label="NAME" />
                  <TableHeadingCol label="EMAIL" />
                  <TableHeadingCol label="PHONE NO." />
                  <TableHeadingCol label="CATEGORY" />
                  <TableHeadingCol label="STATUS" />
                </TableRow>
              </TableHeading>
              <TableBody>
                {data
                  .filter((i) => i.status !== 'pending')
                  .map((tutor) => (
                    <TableRow key={tutor._id} onClick={() => tutor.status !== 'pending' && navigate(tutor._id)}>
                      <TableRowItem tutor={tutor} />
                    </TableRow>
                  ))}
              </TableBody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
